var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImagePrevFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#8D8B96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 8.7998C18.8753 8.7998 16.3425 11.3554 16.3425 14.5079C16.3425 17.6604 18.8753 20.216 21.9996 20.216C25.124 20.216 27.6568 17.6604 27.6568 14.5079C27.6568 11.3554 25.124 8.7998 21.9996 8.7998Z",
    fill: "#F4F3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 35.1998C25.8542 35.1998 29.3486 33.6439 31.8996 31.1206V30.2052C31.8996 26.6586 29.0502 23.7836 25.5353 23.7836H18.4639C14.949 23.7836 12.0996 26.6586 12.0996 30.2052V31.1206C14.6506 33.6439 18.145 35.1998 21.9996 35.1998Z",
    fill: "#F4F3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImagePrevFeedback);
export default __webpack_public_path__ + "static/media/default-image-prev-feedback.e3b2da6d5c73563e652605acdf887225.svg";
export { ForwardRef as ReactComponent };